// extracted by mini-css-extract-plugin
export default {"container":"styles_container__8qY+5","checkbox":"styles_checkbox__fFruo","left":"styles_left__2xqDo","right":"styles_right__-kLKq"};